<template>
    <div class="publicPage landingPage landingAon">
        <div id="hero" :style="'background-image:url('+require('../../../assets/landing/hero-landing-default.jpg')+')'">
            <b-container fluid>
                <b-row>
                    <b-col sm="12" lg="6" class="heroCol">
                        <img class="heroLogo" :src="require('../../../assets/landing/aon.png')" />
                    </b-col>
                    <b-col sm="12" lg="6" class="heroCol">
                        <div class="panel panel-white large-radius">
                            <div class="panel-content">
                                <b-row>
                                    <b-col sm="12" md="6" class="value">
                                        <div class="valueIcon spin"><SvgPurchaseSpin /></div>
                                        <div class="valueText"><p><strong>I Salabam sono voucher per prenotare viaggi online</strong></p></div>
                                    </b-col>
                                    <b-col sm="12" md="6" class="value">
                                        <div class="valueIcon ticket"><SvgTicket /></div>
                                        <div class="valueText"><p><strong>Voucher da 75 a 3.500€ che potrai acquistare usando il tuo credito welfare Aon</strong></p></div>
                                    </b-col>
                                    <b-col sm="12" md="6" class="value">
                                        <div class="valueIcon bed"><SvgPurchaseBed /></div>
                                        <div class="valueText"><p><strong>450.000 hotel, bed&breakfast e appartamenti in Italia e nel mondo prenotabili con pochi click</strong></p></div>
                                    </b-col>
                                    <b-col sm="12" md="6" class="value">
                                        <div class="valueIcon whatsapp"><SvgWhatsapp /></div>
                                        <div class="valueText"><p><strong>Un servizio di supporto a tua disposizione via chat, Whatsapp, telefono e email</strong></p></div>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <b-container class="pageContent">

            <section>
                <div class="boxed">
                    <p>
                        I Salabam sono voucher che permettono di prenotare soggiorni su disponibilità aggiornate in tempo reale e a conferma immediata.
                    </p>
                </div>
            </section>

            <section>
                <div class="infoBox">
                    <div class="header">
                        <div class="boxed">
                            <SvgWarningExplamation /> Perché scegliere Salabam?
                        </div>
                    </div>
                    <div class="content">
                        <div class="boxed">
                            <b-row>
                                <b-col sm="12" lg="6">
                                    <div class="infoIcon">
                                        <SvgCheckedContractCircle />
                                    </div>
                                    <div class="infoHighlight">
                                        <CopyScadenza
                                            default="Validità {value} mesi"
                                            promoMonths="Validità {value} mesi"
                                            promoFixed="Validità fino al {value}"
                                        />
                                    </div>
                                    <div class="infoContent">
                                        <p>
                                            <CopyScadenza />
                                        </p>
                                        <p>
                                            Ricordati che sia la prenotazione sia il viaggio dovranno essere fatti entro la data indicata nel voucher.
                                        </p>                                            
                                    </div>
                                </b-col>
                                <b-col sm="12" lg="6">
                                    <div class="infoIcon">
                                        <SvgRefundCircle />
                                    </div>
                                    <div class="infoHighlight">
                                        Viaggia rimborsabile!
                                    </div>
                                    <div class="infoContent">
                                        <p>
                                            Su Salabam da diverse settimane trovi una grande quantità di soggiorni di tipo rimborsabile.
                                        </p>
                                        <p>
                                            Prenota soggiorni RIMBORSABILI e potrai cancellare ogni prenotazione ottenendo la riattivazione del voucher per un nuovo booking
                                        </p>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <div class="footer">
                        <!--<div class="boxed">footer</div>-->
                    </div>
                </div>
            </section>

            <section>
                <div class="boxed">
                    <h4>
                        Come acquistare un voucher Salabam col tuo credito welfare?
                    </h4>

                    <br>

                    <div class="checklist">
                        <ul>
                            <li>
                                <span class="checklist_index">1</span>
                                <div class="checklist_item">
                                    <span class="checklist_title">SCEGLI IL VOUCHER SALABAM</span>
                                    <p>
                                        Clicca sul bottone VAI ALLO SHOP in fondo alla pagina e trova il voucher adatto al tuo budget e alle tue necessità.
                                        <br><br>
                                        Puoi vedere in tempo reale le disponibilità in oltre 450.000 hotel, B&B, appartamenti in Italia e nel mondo.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <span class="checklist_index">2</span>
                                <div class="checklist_item">
                                    <span class="checklist_title">EFFETTUA L’ORDINE SUL PORTALE WELFARE</span>
                                    <div>
                                        <p>
                                            Torna sul tuo portale welfare <span class="aon">AON OneFlex</span> e ordina il voucher seguendo questi passaggi: area 
                                            <span class="aon">Flexible benefits > Viaggi e vacanze > Cofanetti > Salabam</span>
                                        </p>

                                        <br>

                                        <img :src="require('../../../assets/landing/aon-info.png')" />

                                        <br><br>
                                    </div>

                                </div>
                            </li>
                            <li>
                                <span class="checklist_index">3</span>
                                <div class="checklist_item">
                                    <span class="checklist_title">PRENOTA IL TUO VIAGGIO ONLINE</span>
                                    <p>
                                        Via email riceverai il voucher Salabam che hai scelto e, semplicemente seguendo un link presente nel messaggio, avrai accesso all’area dove potrai prenotare il tuo viaggio.
                                    </p>

                                    <p>
                                        <CopyScadenza
                                            default="Avrai {value} mesi per effettuare la tua prenotazione e viaggiare scegliendo tra disponibilità aggiornate in tempo reale e a conferma immediata."
                                        />                                        
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <section>
                <div class="boxed text-center">
                    <p>
                        <strong>Inizia a navigare il sito alla ricerca del Salabam che fa al caso tuo.<br>Clicca il bottone!</strong>
                    </p>

                    <br>

                    <b-button variant="secondary">
                        <router-link :to="{name: 'shop'}" class="white">Vai allo shop!</router-link>
                    </b-button>

                </div>
            </section>

        </b-container>
    </div>
</template>

<script>
import CopyScadenza from '../../blocks/common/copy-scadenza'
import SvgPurchaseSpin from '../../svg/purchase-spin'
import SvgPurchaseBed from '../../svg/purchase-bed'
import SvgTicket from '../../svg/ticket'
import SvgWhatsapp from '../../svg/whatsapp'
import SvgCheckedContractCircle from '../../svg/checked-contract-circle'
import SvgRefundCircle from '../../svg/refund-circle'
import SvgWarningExplamation from '../../svg/warning-exclamation'

export default {
    name: 'landing-aon',
    components:
    {
        CopyScadenza,
        SvgPurchaseSpin,
        SvgPurchaseBed,
        SvgTicket,
        SvgWhatsapp,
        SvgCheckedContractCircle,
        SvgRefundCircle,
        SvgWarningExplamation,
    },
    data()
    {
        return {
            }
    },
    mounted()
    {
    },
    methods:
    {
    }
}
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../../scss/_custom.scss';

    .landingAon
    {
        .heroLogo
        {
            width: 200px;
        }
        .aon
        {
            color: #E31836;
            font-weight:600;
        }
        .white, .white *
        {
            text-decoration:none !important;
        }
    }
</style>